const Status = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export default (state = { goods: [], codeImg: [], payResult: [] }, action) => {
  switch(action.type) {
    case 'GOODS/INFO_STARTED': {
      return {...state, goodsStatus: Status.LOADING}
    }
    case 'GOODS/INFO_SUCCESS': {
      const result = action.result
      return {...state, goodsStatus: Status.SUCCESS, goods: result}
    }
    case 'GOODS/INFO_FAILURE': {
      return {...state, goodsStatus: Status.FAILURE}
    }
    case 'GOODS/QRCODE_STARTED': {
      return {...state}
    }
    case 'GOODS/QRCODE_SUCCESS': {
      const result = action.result
      return {...state, codeImg: result}
    }
    case 'GOODS/QRCODE_FAILURE': {
      return {...state}
    }
    case 'GOODS/PAYRESULT_SUCCESS': {
      const result = action.result
      return {...state, payResult: result}
    }
    case 'SHOW_MODAL': {
      return {...state, modalShow: true}
    }
    case 'HIDE_MODAL': {
      return {...state, modalShow: false};
    }
    default: {
      return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/goods/reducer.js